// extracted by mini-css-extract-plugin
export default {"columnSpace":"Calculations_columnSpace__I1gSQ","wrongSoilLayers":"Calculations_wrongSoilLayers__wxshs","p":"Calculations_p__yJ8ne","wrapper":"Calculations_wrapper__JVjif"};